import { PollingStatus, StatusProvider } from '@/tax/models';

import { ProcessInputField } from './process-input-field.model';

export class ConnectionCreationProcess {
    id = -1;
    initInputs?: Record<string, any>;
    platform = -1;
    connection = -1;
    inputFields?: ProcessInputField[];
    response?: Record<string, any>;
    creationDate = new Date();
    endDate?: Date;
    status = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;

    deserialize(data: any): this {
        this.id = data.id;
        this.platform = data.platform ?? -1;
        this.connection = data.connection ?? -1;
        this.inputFields = data.input_fields?.map((field: any) => new ProcessInputField().deserialize(field)) ?? undefined;
        this.response = data.response ?? undefined;
        this.creationDate = data.creation_date != undefined ? new Date(data.creation_date) : new Date();
        this.endDate = data.end_date != undefined ? new Date(data.end_date) : undefined;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        return this;
    }

    serialize(): any {
        return {
            'init_inputs': this.initInputs,
            platform: this.platform,
            connection: this.connection,
            response: this.response,
            status: this.status,
        };
    }
}
